import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core'
import { SimpleWindowRefService } from '@ftr/foundation'

/**
 * @deprecated Use `ftrElevioTrigger` directive instead. It opens the
 * side panel widget via the Elevio API — pass `articleId` directly rather than
 * mapping a `cls` selector in the Elevio dashboard.
 */
@Directive({ selector: '[elevioArticle]', standalone: true })
export class ElevioArticleDirective implements AfterViewInit {
  @Input() articleId: string | undefined
  @Input() elevioType = 'article'
  constructor(
    private el: ElementRef,
    private windowRefService: SimpleWindowRefService,
  ) {}

  ngAfterViewInit(): void {
    if (this.articleId) {
      const child = this.windowRefService.document().createElement('elevio-element')
      child.setAttribute('data-type', this.elevioType)
      child.setAttribute('data-id', this.articleId)
      this.el.nativeElement.appendChild(child)
    }
  }
}
